var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.84999 8.14182C3.37594 8.14182 2.99165 8.52611 2.99165 9.00015C2.99165 9.4742 3.37594 9.85849 3.84999 9.85849L8.14158 9.8585L8.14159 14.1503C8.14159 14.6243 8.52588 15.0086 8.99993 15.0086C9.47397 15.0086 9.85826 14.6243 9.85826 14.1503L9.85826 9.8585L14.1501 9.8585C14.6241 9.8585 15.0084 9.47421 15.0084 9.00016C15.0084 8.52611 14.6241 8.14182 14.1501 8.14182L9.85826 8.14182L9.85826 3.85019C9.85826 3.37614 9.47397 2.99185 8.99992 2.99185C8.52587 2.99185 8.14158 3.37614 8.14158 3.85019L8.14158 8.14182L3.84999 8.14182Z",
    fill: "#393D4E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.bad26cd88f3c7ac6bee62fca67b660ce.svg";
export { ForwardRef as ReactComponent };